import { Component, Inject, ChangeDetectionStrategy, InjectionToken } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { EQueryAdminSummary } from '../../models/e-query-admin-summary';
import { EQueryHideStorage, HideEQueryRequest } from '../e-query-hide-storage.service';

export const HIDE_TOKEN = new InjectionToken('HideItem');

@Component({
    selector: 'e-query-hide-dialog',
    template: require('./e-query-hide-dialog.component.html'),
    styles: [require('./e-query-hide-dialog.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EQueryHideDialogComponent {
    public readonly editorForm: FormGroup;
    public readonly textMaxBytes = 150;
    public readonly reasonControl = new FormControl(null);
    public readonly actionTitle: string;

    constructor(
        private readonly dialog: MdlDialogReference,
        private readonly dialogService: MdlDialogService,
        private readonly eQueryHideStorage: EQueryHideStorage,
        @Inject(HIDE_TOKEN) readonly dialogData: EQueryAdminSummary
    ) {
        this.editorForm = new FormGroup({
            'reason': this.reasonControl
        });

        this.actionTitle = 'Hide';
    }

    public async onOk() {
        const confirmed = await this.showConfirm(`The eQuery will be hidden. Please note that this action cannot be undone. Proceed?`);

        if (confirmed) {
            const request: HideEQueryRequest = {
                reason: this.reasonControl.value
            };

            try {
                this.editorForm.disable();

                await this.eQueryHideStorage.hideEQuery(this.dialogData.eQueryId, request);
                await this.eQueryHideStorage.forceLoadEQueries();

                this.dialog.hide();
            } catch (e) {
                this.editorForm.enable();
                throw e;
            }
        }
    }

    public onCancel() {
        this.dialog.hide();
    }

    protected async showConfirm(confirmationText: string): Promise<boolean> {
        try {
            await this.dialogService.confirm(confirmationText, 'No', 'Yes').toPromise();
            return true;
        } catch {
            return false;
        }
    }
}
